<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <div>
            <table>
                <tr>
                    <td>{{$t('getapi[1196]')}}</td>
                    <td>
                        <routejump :urlNo="26">
                            <el-input
                                    v-model="customer_code"
                                    type="text"
                                    readonly
                                    class="mcolor"
                                    size="mini"

                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcustomer()"></i>
                            </el-input>
                        </routejump>
                    </td>
                </tr>
            </table>
        </div>
        <vxe-table
                :data="dataSet1"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                resizable
                :height="tableHeight"
                header-row-class-name="headerclass"
                tab-click="selectInfo(0)"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <vxe-table-column show-overflow-tooltip field="order_date" :title="$t('getapi[463]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_type_code" :title="$t('getapi[1976]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_code" :title="$t('getapi[2095]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="customer_code" :title="$t('getapi[2779]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="payment_type" :title="$t('getapi[13629]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="balance_mode" :title="$t('getapi[1228]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="currency_code" :title="$t('getapi[3740]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="exchange_rate" :title="$t('getapi[3287]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="amount" :title="$t('getapi[3844]')" width="80" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="remain_amount" :title="$t('getapi[3689]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="settlement" :title="$t('getapi[13633]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_no" :title="$t('getapi[1889]')" width="80"></vxe-table-column>
        </vxe-table>
        <vxe-table
                :data="dataSet2"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                resizable
                :height="tableHeight"
                header-row-class-name="headerclass"
                tab-click="selectInfo(0)"
                style="width: 100%; margin-top:0px"
                ref="singleTable"
        >
            <vxe-table-column show-overflow-tooltip field="order_date" :title="$t('getapi[463]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_type_code" :title="$t('getapi[1976]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_code" :title="$t('getapi[2095]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="due_date" :title="$t('getapi[13467]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="customer_code" :title="$t('getapi[2779]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="currency_code" :title="$t('getapi[3740]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="amount" :title="$t('getapi[3844]')" width="80" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="remain_amount" :title="$t('getapi[3689]')" width="80" align="right"></vxe-table-column>
            <!--<vxe-table-column show-overflow-tooltip field="enjoy_discount" :title="$t('getapi[13630]')" width="80" align="right"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="discount" :title="$t('getapi[13631]')" width="80" align="right"></vxe-table-column>-->
            <vxe-table-column show-overflow-tooltip field="settlement" :title="$t('getapi[13633]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="order_no" :title="$t('getapi[1889]')" width="80"></vxe-table-column>
            <vxe-table-column show-overflow-tooltip field="vouch_no" :title="$t('getapi[13634]')" width="80"></vxe-table-column>
        </vxe-table>
        <!-- 供应商代码 -->
        <selector :isVisible="false" :isBatch=false :selectType="0" :isSplitPage=true
                  :postUrl="'/Finance/PayMent/GetVenderCodePopuDataList'" @callback="getvender" ref="vender"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '3_rwriteoff',
        computed: {
            tableHeight(){
                return (this.$windowSize.tableHeight3 / 2)
            }
        },
        data() {
            return {
                tableHeader: [],
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet1: [], // 主表数据
                dataSet2: [], // 主表数据
                customer_code:'',
            };
        },
        beforeMount(){
            let that = this;
            that.colsort();
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_rwriteoff', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.$http.urlpost('CurrencySource', {}, function (res) {
                if (res.Success == 1) {
                    that.Currency = res.DataContent;
                }
            });
            that.$nextTick(function () {
                that.$processdata.initForm()
            })
        },
        activated () {
            let that = this
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[5077]"),this.$t("getapi[5131]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
            },
            selectcustomer(){
                let that = this
                that.$refs.customer.clearInput(true);
            },
            getcustomer(data){
                let that = this
                console.log(data)
                that.customer_code = data.customer_id
            },
            search(){
                let that = this
                let parm = {
                    Code : that.customer_code
                }
                that.$http.urlpost('/Finance/RWriteOff/RWriteOffView', parm, function (res) {
                    if (res.Success == 1) {
                        let list = res.DataContent;
                        if(list){
                            that.dataSet1 = list.Listspm
                            that.dataSet2 = list.Listspa
                            that.authority();
                        }
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    span.title {
        width: 100%;
        display: flex;
        height: 40px;
        line-height: 40px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .el-textarea {
        display: block;
    }
</style>
